export const MENTIONS_WORDS_QUANTITY_LIMIT = 200;
